import { lazy, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import type { UnicornApi } from '@cld/unicorn-api';

import { RemoteModule } from '../../components/remote-module/remote-module.js';
import { useThumbnailsAuthorization } from '../../hooks/thumbnails.hooks.js';
import { extractBasename } from './extractBasename.js';

const RemoteManageTransformations = lazy(() =>
  import('@cld-remote/transformations_page_app/index').then(({ ManageTransformations }) => ({
    default: ManageTransformations,
  }))
);

export interface ManageTransformationsProps {
  navigateOutsideApplication(path: string): void;
  unicornApi: UnicornApi;
}

export const ManageTransformationsPage = ({ navigateOutsideApplication, unicornApi }: ManageTransformationsProps) => {
  const basename = extractBasename('manage'); // Base path for the router
  const { productEnvironment } = unicornApi.data;

  const navigate = useNavigate();
  const authorizationPromise = useThumbnailsAuthorization(productEnvironment.cloudName);

  const navigateToTransformationBuilder = useCallback(
    (params: Record<string, string> = {}) => {
      const searchParams = new URLSearchParams(params).toString();

      if (searchParams) {
        navigate(`../../transformation_builder?${searchParams}`);
      } else {
        navigate(`../../transformation_builder`);
      }
    },
    [navigate]
  );

  return (
    <RemoteModule>
      <RemoteManageTransformations
        basename={basename}
        unicornApi={unicornApi}
        navigateOutsideApplication={navigateOutsideApplication}
        navigateToTransformationBuilder={navigateToTransformationBuilder}
        thumbnailAuthorizationStatus={authorizationPromise}
      />
    </RemoteModule>
  );
};
